import { Injectable } from '@angular/core';
import { DatasourceTableJobQuery } from '@y42/datasource';
import { DateTimeService } from '@y42/date-time';
import { OrgUserQuery } from '@y42/org-user/state';
import { SqlModelingTableStoreQuery } from '../datasource-table/sql-modeling-table.store-query';
import { SqlModelingStoreQuery } from '../datasource/sql-modeling.store-query';
import { SqlModelingJobSettingsValidationService } from './sql-modeling-job-settings-validation/sql-modeling-job-settings-validation.service';
import { SqlModelingTableJobStore } from './sql-modeling-table-job.store';

@Injectable({ providedIn: 'root' })
export class SqlModelingTableJobQuery extends DatasourceTableJobQuery {
  constructor(
    store: SqlModelingTableJobStore,
    dateTimeService: DateTimeService,
    grandParentQuery: SqlModelingStoreQuery,
    parentQuery: SqlModelingTableStoreQuery,
    orgUserQuery: OrgUserQuery,
    jobSettingsValidationService: SqlModelingJobSettingsValidationService,
  ) {
    super(store, dateTimeService, grandParentQuery, parentQuery, orgUserQuery, jobSettingsValidationService);
  }
}
